import { Stack } from "@fluentui/react";
import React from "react";
import { CSSProperties } from "react";
import { ShimmerLineProps } from "../../Shimmer/Shimmer.types";
import { ShimmerLine } from "../../Shimmer/ShimmerLine/ShimmerLine";

const firstLineWidth = 145;
const lineHeight = 16;

const dropDownShimmerStyle: CSSProperties = {
    height: 45
};

interface DropdownShimmerProps extends Pick<ShimmerLineProps, "width"> { }

export const DropdownShimmer: React.FC<DropdownShimmerProps> = ({ width = firstLineWidth }) => (
    <Stack style={dropDownShimmerStyle} verticalAlign="center">
        <ShimmerLine width={width} height={lineHeight} />
    </Stack >
);
